import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService, Message } from 'primeng/api';
import { SacadoService } from 'src/app/_services/sacado.service';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Cedente } from 'src/app/_models/cedente/cedente';
import { Sacado } from 'src/app/_models/sacado/sacado';
import { CedenteService } from 'src/app/_services/cedente.service';
import { FilterSacado } from 'src/app/_models/filter/FilterSacado';
import { Perfil } from 'src/app/_models/usuario/perfil';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { EmailSacadoService } from 'src/app/_services/emailSacado.service';
import { Titulo } from 'src/app/_models/titulo/titulo';
import { Image } from 'src/app/demo/domain/image';
import { Usuario } from 'src/app/_models/usuario/usuario';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { EmailSacado } from 'src/app/_models/titulo/emailSacado';
import { SacadoTitulo } from 'src/app/_models/sacado/sacadoTitulo';

@Component({
  templateUrl: 'sacado.component.html',
  styleUrls: ['sacado.scss'],
    styles: [`
        :host ::ng-deep .p-dialog .product-image {
            width: 150px;
            margin: 0 auto 2rem auto;
            display: block;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                text-align: center;
            }

            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }
}

    `],
    providers: [MessageService, ConfirmationService, DatePipe, CurrencyPipe]
})

export class SacadoComponent implements OnInit {

    filterSacado: FilterSacado  = {};
    cedentes: Cedente[];
    cedente: Cedente;
    cols: any[];
    selectedCedente: Cedente[];
    filteredCedentes: Cedente[];
    filteredSacados: Sacado[];
    selectedCedentesAdvanced: Cedente[];
    msgs: Message[] = [];
    sacados: Sacado[];
    sacadosCb: Sacado[];
    sacadosFiltro: Sacado[];
    documento: string;
    perfil: Perfil;
    sacadoDialog: boolean;
    image: Image;
    url: SafeUrl;
    currentUsuario: Usuario;
    pesquisarSacadoLabel: string;
    pesquisandoProgress: boolean;
    header: any[];
    innerHeader: any;
    titulo: SacadoTitulo;
    emailSacado: EmailSacado;
    tituloDialog: boolean;
    submitted: boolean;
    emailSacadoReturn: EmailSacado;
    sacadoEmail: Sacado;
    mostrarPesquisaSacado = false;
    documentoSacado = "";

  constructor(private sacadoService: SacadoService, private cedenteService: CedenteService, private messageService: MessageService,
              private breadcrumbService: AppBreadcrumbService, private authenticationService: AuthenticationService,
              private emailSacadoService: EmailSacadoService, private sanitizer: DomSanitizer,
              private bscobrancaTranslate: BscobrancaTranslate, private datepipe: DatePipe, private currencyPipe: CurrencyPipe) {
        this.pesquisarSacadoLabel = this.bscobrancaTranslate.getText('menu.pesquisarSacado');
        this.breadcrumbService.setItems([
            { label: this.pesquisarSacadoLabel, routerLink: ['/sacado/sacado']  }
        ]);
        this.header = ['Documento', 'Nome', 'Banco', 'Nosso Numero', 'Data Vencimento', 'Valor', 'Status'];
    }

   ngOnInit(): void {
        this.currentUsuario = this.authenticationService.atualUserValue;
        this.cedente = {};
        this.perfil = this.authenticationService.atualUserPerfilValue;
        this.cedenteService.getCedentesPorEmpresa(-1)
            .subscribe(ceds => {
            this.cedentes = Array.from(ceds);
            });
        if (this.perfil.nmePerfil === 'CONSSACADO') {
            this.pesquisandoProgress = true;
            this.filterSacado = {};
            this.filterSacado.nmePerfil = this.perfil.nmePerfil;
            this.filterSacado.documentoSacado = this.currentUsuario.nroCpf;
            this.filterSacado.cedente = {};
            this.filterSacado.cedente.codInscricao = this.currentUsuario.empresa.nroCNPJ;
            this.sacadoService.getSacado(this.filterSacado)
                .subscribe(
                    result => {this.sacados = result; } ,
                    err => console.log(err),
                    () => {
                    this.pesquisandoProgress = false;
            });
            this.pesquisandoProgress = false;
        }
        if(this.perfil.nmePerfil === 'OPRCEDENTE' || this.perfil.nmePerfil === 'ADMCEDENTE') {
            this.sacadoService.findByCedenteCodInscricao(this.currentUsuario.empresa.nroCNPJ)
            .subscribe(sacds => {
                this.sacadosCb = Array.from(sacds);
                this.sacadosFiltro = Array.from(sacds);
                this.mostrarPesquisaSacado = true;
            });
        }
    }

    hideDialog() {
        this.sacadoDialog = false;
    }

    viewBoleto(titulo: SacadoTitulo, sacado: Sacado) {
      this.titulo = titulo;
      this.sacadoEmail = {};
      this.sacadoEmail = sacado;
      this.emailSacadoService.getImageTitulo(titulo.codTitulo).subscribe((data) => {
        const file = new Blob([data], {type: 'image/png'});
        console.log(file);
        const urlCreator = window.URL;
        this.url = this.sanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(new Blob([data], {type: 'image/png'})));
        console.log(this.url);
        this.sacadoDialog = true;
       });
    }

    sendEditBanco(titulo: SacadoTitulo, sacado: Sacado) {
            this.titulo = titulo;
            this.sacadoEmail = {};
            this.sacadoEmail = sacado;
            this.emailSacado = {};
            this.submitted = false;
            this.tituloDialog = true;
    }

    sendEmail(titulo: SacadoTitulo) {
            this.messageService.clear();
            this.emailSacadoReturn = {};
            this.emailSacado.codSacado = this.sacadoEmail.codSacado;
            this.emailSacado.codTitulo = titulo.codTitulo;
            this.emailSacado.codCedente = titulo.codigoPortal;
            this.emailSacadoService.sendEmail(this.emailSacado).subscribe(
                    response => this.emailSacadoReturn = response,
                    err => console.log(err));
            this.tituloDialog = false;
            this.submitted = false;
            this.messageService.add({severity: 'success', summary: 'Successful', detail: this.bscobrancaTranslate.getText('mensagens.titulo-006'), life: 3000});
    }

    hideDialogTitulo() {
            this.tituloDialog = false;
            this.submitted = false;
    }

    downloadPdf() {
        this.emailSacadoService.getPdfTitulo(this.titulo.codTitulo).subscribe((res) => {
                const blob = new Blob([res], { type: 'application/pdf' });
                const dwldLink = document.createElement('a');
                const url = URL.createObjectURL(blob);
                const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
                if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
                    dwldLink.setAttribute('target', '_blank');
                }
                dwldLink.setAttribute('href', url);
                dwldLink.setAttribute('download', this.sacadoEmail.nmeSacado + '.pdf');
                dwldLink.style.visibility = 'hidden';
                document.body.appendChild(dwldLink);
                dwldLink.click();
                document.body.removeChild(dwldLink);
            });
        }


    printComponent(cmpName) {
        const printContents = document.getElementById(cmpName).innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }



   limparFormulario(): void {
        this.msgs = [];
        this.filterSacado = {};
        this.cedente = {};
        this.sacados = [];
        this.documento = '';
        this.documentoSacado = '';
        this.mostrarPesquisaSacado = false;
        if(this.perfil.nmePerfil === 'OPRCEDENTE' || this.perfil.nmePerfil === 'ADMCEDENTE') {
            this.sacadoService.findByCedenteCodInscricao(this.currentUsuario.empresa.nroCNPJ)
            .subscribe(sacds => {
                this.sacadosCb = Array.from(sacds);
                this.sacadosFiltro = Array.from(sacds);
                this.mostrarPesquisaSacado = true;
            });
        }
    }

    validarPesquisa() {
        if (this.perfil.nmePerfil === 'ADMTIVIT' || this.perfil.nmePerfil === 'MNGTIVIT' || this.perfil.nmePerfil === 'OPRTIVIT') {
            if ((!this.documento || this.documento === '') && !this.cedente) {
                return this.bscobrancaTranslate.getText('mensagens.sacaodo-001');
            }
            if (!this.documento) {
                this.filterSacado.documentoSacado = this.documento;
            }
            if (!this.cedente) {
                this.filterSacado.cedente = this.cedente;
            }
        } else {
            this.filterSacado.documentoSacado = this.currentUsuario.nroCpf;
            this.filterSacado.cedente = {};
            this.filterSacado.cedente.codInscricao = this.currentUsuario.empresa.nroCNPJ;
        }
        return '';
    }

    pesquisarSacado(): void {
        this.msgs = [];
        const error: string = this.validarPesquisa();
        if (error !== '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Erro:', detail: error });
        } else {
            this.pesquisandoProgress = true;
            this.msgs = [];
            this.filterSacado.documentoSacado = this.documento;
            this.filterSacado.documento = this.documento;
            this.filterSacado.nmePerfil = this.perfil.nmePerfil;
            if (this.perfil.nmePerfil !== 'ADMTIVIT' && this.perfil.nmePerfil !== 'MNGTIVIT' && this.perfil.nmePerfil !== 'OPRTIVIT') {
                this.cedente = {}
                this.cedente.codInscricao = this.currentUsuario.empresa.nroCNPJ;
            }
            if (this.cedente) {
                this.filterSacado.cedente = this.cedente;
            }
            if(this.documentoSacado.length > 1) {
                this.filterSacado.documentoSacado = this.documentoSacado;
            }

            this.sacadoService.getSacado(this.filterSacado)
                .subscribe(
                    result => {this.sacados = result; } ,
                    err => console.log(err),
                    () => {
                    this.pesquisandoProgress = false;
            });
        }
    }

   filterCedentes(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.cedentes.length; i++) {
            const cedente = this.cedentes[i];
            if (cedente.nmeCedente.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(cedente);
            }
        }

        this.filteredCedentes = filtered;
    }

    filterSacados(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.sacadosFiltro.length; i++) {
            const sacado = this.sacadosFiltro[i];
            if (sacado.nmeSacado && sacado.nmeSacado.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(sacado);
            }
        }

        this.filteredSacados = filtered;
    }

    numberOnly(event: { which: any; keyCode: any; }): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    downloadFile(filename= 'sacado') {
        const csvData = this.ConvertToCSV(this.header);
        console.log(csvData);
        const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        const dwldLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
            dwldLink.setAttribute('target', '_blank');
        }
        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '.csv');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    ConvertToCSV(headerList: any[]) {
         let str = '';
         let row = 'No;';
         // tslint:disable-next-line: forin
         for (const index in headerList) {
                row += headerList[index] + ';';
             }
         row = row.slice(0, -1);
         str += row + '\r\n';
         for (let i = 0; i < this.sacados.length; i++) {
             const sac = this.sacados[i];
             let line = (i + 1) + ';';
             if (sac.titulos && sac.titulos.length > 0) {
                 // tslint:disable-next-line: prefer-for-of
                 for (let x = 0; x < sac.titulos.length; x++) {
                    line += sac.codInscricaoSacado + ';';
                    line += sac.nmeSacado + ';';
                    const tit = sac.titulos[x];
                    line += tit.bancoResponsavel.nmeBanco + ';';
                    line += Number(tit.codNossoNumero) + ';';
                    line += this.datepipe.transform(tit.dtaVencimento, 'dd/MM/yyyy') + ';';
                    line += this.currencyPipe.transform(tit.vlrTitulo, 'BRL') + ';';
                    if (tit.statusBoleto) {
                        line += tit.statusBoleto.desStatusBoleto + ';';
                    } else {
                        line += '' + ';';
                    }
                    line += '\r\n';
                    str += line;
                    line = (i + 1) + ';';
                }
            }
         }
         return str;
     }

    cedenteFindByCodigo(cedente: Cedente) {
        this.sacadoService.findByCedenteId(cedente.codCedente)
            .subscribe(sacds => {
                this.sacadosCb = Array.from(sacds);
                this.sacadosFiltro = Array.from(sacds);
                this.mostrarPesquisaSacado = true;
            });
    }

    sacadoFindBy(sacado: Sacado) {
            this.documentoSacado = sacado.codInscricaoSacado;
    }

    exportOptions = [
        {label: 'PDF', icon: 'pi pi-file-pdf', command: (x) => this.exportarConsultaSacados('PDF') },
        {label: 'XLS', icon: 'pi pi-file-excel', command: (x) => this.exportarConsultaSacados('XLSX')}
    ];

    exportarConsultaSacados(formato: string) {
        this.filterSacado.documentoSacado = this.documento;
        this.filterSacado.documento = this.documento;
        this.filterSacado.nmePerfil = this.perfil.nmePerfil;
        if (this.perfil.nmePerfil !== 'ADMTIVIT' && this.perfil.nmePerfil !== 'MNGTIVIT' && this.perfil.nmePerfil !== 'OPRTIVIT') {
            this.cedente = {}
            this.cedente.codInscricao = this.currentUsuario.empresa.nroCNPJ;
        }

        if (this.perfil.nmePerfil === 'CONSSACADO') {
            this.filterSacado.documentoSacado = this.currentUsuario.nroCpf;
            this.filterSacado.cedente.codInscricao = this.currentUsuario.empresa.nroCNPJ;
        }

        if (this.cedente) {
            this.filterSacado.cedente = this.cedente;
        }

        if(this.documentoSacado.length > 1) {
            this.filterSacado.documentoSacado = this.documentoSacado;
        }
        this.filterSacado.formatoRelatorio = formato;
        this.sacadoService.exportarRelatorioSacados(this.filterSacado).subscribe((res: any) => {

            const file = new Blob([res], {
                type: res.type,

            });
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Sacados.` + formato;
            link.click();
            window.URL.revokeObjectURL(url);
            link.remove();
        }, error => {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Erro:', detail: "Não existe títulos para o sacado selecionado na pesquisa." });
        });
    }

}
